import { lazy } from "react";
import type { Modul } from "../../kern/modul";
import { useBudgetKennzahl } from "./kennzahl";

// Das Budget erst laden, wenn jemand den Reiter öffnet
const Budget = lazy(() => import("./Budget").then((m) => ({ default: m.Budget })));

/** Budget je Vorhaben (Paket D, ADR-016). Keine eigene Seite: ein Reiter in der Kapsel und eine Kennzahl auf der Karte unter /vorhaben. */
export const finanzen: Modul = {
  id: "finanzen",
  name: "Finanzen",
  routen: [],
  navigation: [],
  ereignisse: ["finanzen.posten_angelegt", "finanzen.posten_bearbeitet", "finanzen.posten_geloescht"],
  kapselReiter: [
    {
      id: "budget",
      label: "Budget",
      // Nicht beim Förderantrag (BAUPLAN-VORHABEN-ARTEN.md, Abschnitt 2)
      arten: ["veranstaltung", "projekt"],
      // Vorstand über das Recht, die Leitung über ihre Rolle im Vorhaben. Mitwirkende sehen den Reiter nicht (kein gesperrter Reiter).
      recht: "finanzen.verwalten",
      pruefen: (lage) => lage.meineRolle === "leitend",
      reihenfolge: 20,
      inhalt: Budget,
    },
  ],
  kapselKennzahlen: [
    {
      id: "budget",
      label: "Budget, Plan",
      arten: ["veranstaltung", "projekt"],
      // Wie der Reiter: Vorstand über das Recht, die Leitung über ihre Rolle
      recht: "finanzen.verwalten",
      pruefen: (lage) => lage.meineRolle === "leitend",
      reihenfolge: 20,
      wert: useBudgetKennzahl,
    },
  ],
};
